export const sizeTypes = new Set(['sm', 'md', 'lg']);
